
<div class="card" style="min-height: 80vh;">
  <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-2 d-flex align-items-center justify-content-between">
              <button (click)="isAsideNavCollapsed = !isAsideNavCollapsed" [attr.aria-expanded]="!isAsideNavCollapsed"
                      aria-controls="asideNav" class="navbar-toggle btn btn-icon border d-inline-flex d-lg-none"
                      type="button">
                <i class="feather icon-chevron-down"></i>
              </button>
            </div>
            <div class="col-10 order-md-first text-lg-start d-flex flex-wrap justify-content">
              <a style="margin: 9px;" class="btn bg-danger-custom" id="contact" routerLink="/merchants/merchant-master"><i class="feather icon-arrow-left"></i>Back</a>
              <h5 class="mb-3 mt-3" *ngIf="isAdd; else ifNotShow">{{'Merchant/Agent On-Boarding ('+createId+')'}}</h5>
              <ng-template #ifNotShow><h5 class="mb-3 mt-3">{{isSubMerchant?'Partner {'+resellerName+'}':'Merchant/Agent On-Boarding' }} <span style="color:#6571ff">{{isSubMerchant?'ID: '+partnerIdentifier:'('+createId+')'}}</span></h5></ng-template>
              <p *ngIf="!isAdd" class="text-muted">{{selectedMerchantId}}</p>
              <div class="w-100">
                <p *ngIf="isSubMerchant" class="mb-0 text-muted-grey" style="margin-left: 95px; margin-top:-25px">Merchant</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
      

          <div class="text-end mb-2 mt-3">
            <div class="btn-group pull-right">
              <button (click)="previousStep($event)" *ngIf="this.previousPath" [disabled]="disableMenu" class="btn btn-primary"
                      type="button">
                <i class="feather icon-chevron-left"></i>Back
              </button>
              <button (click)="nextStep($event)" *ngIf="this.nextPath" [disabled]="disableMenu" class="btn btn-primary"
                      type="button">
                Next<i class="feather icon-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
      <div class="card-body m-0" style="min-height: 80vh; padding-bottom: 80px;">
    <div class="row" style="margin-right: 0!important;">
      <div class="col-sm-2 col-sm border-end-lg">
<div class="bg-sidebar">
          <div #collapse="ngbCollapse" [(ngbCollapse)]="isAsideNavCollapsed" class="merchant-creation-aside-nav" id="asideNav">
            <ul class="nav flex-column">
              <ng-container #menuListItem *ngFor="let item of menuItems">
                <li [ngClass]="{'active': inbox.isActive}" class="nav-item">
                  <a #inbox="routerLinkActive"
                     [ngClass]="{'disabled': disableMenu && item.link !== '/merchants/merchant-creation/merchant-add'}"
                     class="nav-link d-flex align-items-center"
                     queryParamsHandling="preserve" routerLink="{{item.link}}" [state]="{ data: menuItems}"
                     routerLinkActive="active"
                     (click)="isAsideNavCollapsed = !isAsideNavCollapsed"
                  >
                    <i class="feather {{item.icon}} icon-lg me-2"></i>
                    {{item.label | titlecase}}
                  </a>
                </li>
              </ng-container>

          </ul>
        </div>
      </div>
      </div>
      <div class="col-sm-10 col-sm">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

